import { List, OrderedMap } from 'immutable';
import { SheetMap } from 'records/Sheet';
import { Markup } from 'records/Markup';
import { SheetVersion } from 'records/SheetVersion';
import { RFI } from 'records/RFI';

export function getRfiMarkupSheets(
  markups: List<Markup>,
  sheets: SheetMap
): List<SheetVersion> {
  if (markups.size === 0) {
    return List<SheetVersion>();
  }

  const sheetsWithMarkup = markups.map(
    (markup) =>
      sheets
        .valueSeq()
        .flatMap((sheet) => sheet.versions)
        .find((sheet) => sheet.pageid === markup.fileid) || new SheetVersion()
  );

  return sheetsWithMarkup;
}

export function sortRfisFromGroups(
  sortedRFIs: OrderedMap<string, List<RFI>>
): OrderedMap<string, RFI> {
  const updatedRFIList = sortedRFIs.reduce(
    (acc: OrderedMap<string, RFI>, rfisInGroup: List<RFI>) => {
      const rfiList = rfisInGroup.reduce(
        (groupAcc: OrderedMap<string, RFI>, rfi: RFI) =>
          groupAcc.set(rfi.id, rfi),
        OrderedMap<string, RFI>()
      );

      return acc.concat(rfiList);
    },
    OrderedMap()
  );

  return updatedRFIList;
}
